import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class AppVersionInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    
    const modifiedReq = req.clone({
      setHeaders: {
        'X-App-Name': 'portal',
        'X-App-Version': environment.version,
        'X-App-Env': environment.tag
      }
    });

    return next.handle(modifiedReq);
  }
}
